import CardWrapper from "components/commons/cardWrapper/CardWrapper";
import { strings } from "intl/fa";
import infoStyles from "./SponsoredInfo.module.scss";
import styles from "./SponsoredImageStep.module.scss";
import Footer from "components/commons/footer/Footer";
import { Divider, DividerThickness, NewButton, NewButtonSize } from "@bale/ui";
import {
  FileErrors,
  FileValidators,
  useFileHandler,
} from "hooks/useFileHandler";
import { GeneralErrors } from "hooks/useInputHandler";
import { Bubble } from "components/content/sponsoredMessage/steps/4_preview/Bubble";
import { useAppDispatch, useAppSelector } from "utils/store";
import { OrderAdActions, OrderAdPages } from "core/orderAd/orderAd.slice";
import { useEffect, useState } from "react";
import ImageCropInput from "components/commons/ImageInput/ImageCropInput";
import classNames from "classnames";
import { MAX_SPONSORED_MESSAGE_IMAGE_SIZE } from "utils/constants";

export const SponsoredImageStep = () => {
  const orderAdInfo = useAppSelector((state) => state.orderAd.info);
  const dispatch = useAppDispatch();
  const [croppedImageURL, setCroppedImageURL] = useState<string>();

  function onSubmit() {
    dispatch(
      OrderAdActions.setOrderAdInfo({
        croppedImageURL: croppedImageURL,
      })
    );
    dispatch(OrderAdActions.setPage(OrderAdPages.SponsoredDetails));
  }

  const adImageHandler = useFileHandler({
    rules: [
      FileValidators.maximumSize(MAX_SPONSORED_MESSAGE_IMAGE_SIZE),
      FileValidators.required,
    ],
    errorMessages: {
      [FileErrors.MaximumSize]: strings.common.error.image_max_size,
      [GeneralErrors.Required]: strings.common.error.required,
    },
  });

  // to restore state when changing step
  useEffect(() => {
    if (orderAdInfo.croppedImageURL) {
      setCroppedImageURL(orderAdInfo.croppedImageURL);
    }
  }, [orderAdInfo.croppedImageURL]);

  return (
    <>
      <div className={infoStyles.Content}>
        <CardWrapper className={classNames(infoStyles.Card, styles.Card)}>
          <p className={infoStyles.inputTitle}>
            {strings.sponsored_messages.imageStep.imageInput}
          </p>
          <ImageCropInput
            {...adImageHandler}
            helpText={strings.dialog_ad_form.info_step.image_size_limit_info}
            beforeSelectLabel={strings.common.input.image.label}
            croppedImageURL={croppedImageURL}
            setCroppedImageURL={setCroppedImageURL}
          />
          {croppedImageURL && (
            <>
              <Divider thickness={DividerThickness.Thin} />
              <p className={infoStyles.inputTitle}>
                {strings.sponsored_messages.imageStep.preview}
              </p>
              <p className={styles.HelperText}>
                {strings.sponsored_messages.imageStep.previewHelper}
              </p>
              {croppedImageURL && (
                <Bubble
                  caption={orderAdInfo.description || ""}
                  button_link={orderAdInfo.link}
                  button_title={orderAdInfo.link_title}
                  imageSrc={croppedImageURL}
                />
              )}
            </>
          )}
        </CardWrapper>
      </div>
      <Footer>
        <NewButton
          onClick={onSubmit}
          className={infoStyles.Button}
          size={NewButtonSize.LARGE}
        >
          {strings.common.button.submit_and_continue}
        </NewButton>
      </Footer>
    </>
  );
};
